export const BookingStatus = [
    { label: "OPEN", value: "OPEN", color: "#b5651d", backgroundColor: "#bb6528" },
    { label: "CLOSED", value: "CLOSED", color: "#24CB3F", backgroundColor: "#DEFFD8" },
    { label: "CANCELED", value: "CANCELED", color: "#FF0017", backgroundColor: "#FFC8CD" },
  ];
  
  export const BookingPriority = [
    { label: "LOW", value: "LOW", color: "#24CB3F", backgroundColor: "#DEFFD8" },
    { label: "MEDIUM", value: "MEDIUM", color: "#FF9012", backgroundColor: "#FFE1BF"},
    { label: "HIGH", value: "HIGH", color: "#FF0017",  backgroundColor: "#FFC8CD"},
  ];
  
  export const PaymentStatus = [
    { label: "PENDING", value: "PENDING", color: "#FF0017", backgroundColor: "#FFC8CD" },
    { label: "RECEIVED", value: "RECEIVED", color: "#24CB3F", backgroundColor: "#A7EAB2" },
    { label: "PAID_THROUGH_WEB", value: "PAID_THROUGH_WEB", color: "#FF9012", backgroundColor: "#FFE1BF" },
  ];
  
  export const DocumentStatus = [
    { label: "IN_PROCESS", value: "IN_PROCESS", color: "#FF9012", backgroundColor: "#ffc790"  },
    { label: "SENT_ON_WATSAPP", value: "SENT_ON_WATSAPP", color: "#24CB3F", backgroundColor: "#24CB3F"  },
    { label: "SENT_ON_EMAIL", value: "SENT_ON_EMAIL", color: "#009DFF", backgroundColor: "#BFE6FF"  },
    { label: "SENT_VIA_WEBSITE", value: "SENT_VIA_WEBSITE", color: "#673AB7", backgroundColor: "#DEFFD8"  },
    { label: "NOT_REQUIRED", value: "NOT_REQUIRED", color: "#999", backgroundColor: "#F3F3F3"  },
    { label: "ON_HOLD", value: "ON_HOLD", color: "#FF0017", backgroundColor: "#FFC8CD"  },
    { label: "NOT_PROCESS", value: "NOT_PROCESS", color: "#3788C5", backgroundColor: "#3788C5"  },
    { label: "HARD_DRIVE", value: "HARD_DRIVE", color: "##AEB61F", backgroundColor: "#FCFFC3"  },
  ];
  
  export const BookingReceived = [
    { label: "WHATSAPP", value: "WHATSAPP", color: "#24CB3F", backgroundColor: "#DEFFD8" },
    { label: "G_FORM", value: "G-FORM", color: "#673AB7", backgroundColor: "#E0CEFF" },
    { label: "EMAIL", value: "EMAIL", color: "#009DFF", backgroundColor: "#BFE6FF" },
    { label: "WEBSITE", value: "WEBSITE", color: "#FF9012", backgroundColor: "#FFE1BF" },
    { label: "NEPAL_OFFICE", value: "NEPAL_OFFICE", color: "#B6C10F",backgroundColor: "#F7FFCB" },
  ];
  
  export const BookingType = [
    { label: "Bulk", value: "BULK", color: "#24CB3F", backgroundColor: "#DEFFD8" },
    { label: "Single", value: "SINGLE", color: "#673AB7", backgroundColor: "#E0CEFF" },
  ];

  export const InsuranceRepresentatives = [
    { label: "Ankit", value: "ankit" },
    { label: "Geeta", value: "geeta" },
    { label: "Manju", value: "manju" },
  ];